import React from 'react';

import PropTypes from 'prop-types';

// import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';

import './InputField.less';

function InputField({
  label,
  label2,
  inputValue,
  unit,
  onClick,
  hideField,
  fullWidthInput,
  disabled,
  type,
  labelClassname: labelClassName,
  inputClassName,
  unitClassName,
}) {
  // const middleLine = label2 ? '' : 'middle-line';
  const classLabelColumn = fullWidthInput ? APPSTYLE.COLUMN_INPUT_NORMAL_UNIT : APPSTYLE.COLUMN_LABEL_NORMAL;
  // eslint-disable-next-line no-nested-ternary
  const classInputCollumn = fullWidthInput
    ? // ? unit === undefined
      //     ? "col-xs-9 col-md-9 col-lg-9 col-xl-9 "
      //     : "col-xs-8 col-md-8 col-lg-8 col-xl-8 "
      // : unit === undefined
      // ? "col-xs-5 col-md-5 col-lg-5 col-xl-5 "
      // : "col-xs-4 col-md-4 col-lg-4 col-xl-4 ";
      unit
      ? APPSTYLE.COLUMN_INPUT_FULL_WIDTH_NO_UNIT
      : APPSTYLE.COLUMN_INPUT_FULL_WIDTH_UNIT
    : unit
    ? APPSTYLE.COLUMN_INPUT_NORMAL_NO_UNIT
    : APPSTYLE.COLUMN_INPUT_NORMAL_UNIT;
  const classInputField = fullWidthInput ? 'inputField inputFullWitdh' : 'inputField';
  const inputType = type || 'text'; // : 'password';
  const value = inputValue;

  // if (inputValue === APPDATA.EMPTY_FIELD) value = '';
  // else if (typeof inputValue === 'number' && inputValue === APPDATA.EMPTY_FIELD_NUMERIC) value = '';

  return (
    <div
      className="middleAlign"
      style={{marginBottom: '5px'}}
    >
      <div className={labelClassName ? `${classLabelColumn} ${labelClassName}` : classLabelColumn}>
        {!hideField && (
          <div className="row row-margin">
            <span
              className={labelClassName ? `spanStyleInputField ${labelClassName}` : 'spanStyleInputField'}
              disabled={disabled}
            >
              {label}
            </span>
          </div>
        )}
        {!hideField && label2 && (
          <div className="row row-margin">
            <span className="spanStyleInputField"> {label2} </span>
          </div>
        )}
      </div>
      <div className={` ${inputClassName || classInputCollumn}`}>
        {!hideField && (
          <input
            className={classInputField}
            id={label}
            type={inputType}
            value={value}
            readOnly
            onClick={onClick}
            disabled={disabled}
          />
        )}
      </div>
      {unit !== undefined && (
        <div className={`${unitClassName || APPSTYLE.COLUMN_UNIT}`}>
          {!hideField && <span className="spanStyleInputField unit"> {unit} </span>}
        </div>
      )}
    </div>
  );
}

InputField.propTypes = {
  label: PropTypes.string,
  label2: PropTypes.string,
  inputValue: PropTypes.string,
  unit: PropTypes.string,
  onClick: PropTypes.func,
  hideField: PropTypes.bool,
  fullWidthInput: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  labelClassname: PropTypes.string,
  inputClassName: PropTypes.string,
  unitClassName: PropTypes.string,
};

InputField.defaultProps = {
  label: '',
  label2: '',
  inputValue: '',
  unit: '',
  onClick: () => {},
  hideField: false,
  fullWidthInput: false,
  disabled: false,
  type: '',
  labelClassname: '',
  inputClassName: '',
  unitClassName: '',
};

export default InputField;
